import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '@core/auth/useAuth'

const DISMISS_KEY = 'vn2r.passwordBannerDismissedAt'

/**
 * Subtle one-line strip that nudges users without a password to set
 * one. Reads `hasPassword` from AuthContext (kept in sync via /me),
 * so the banner disappears immediately after the user defines their
 * password elsewhere, no stale fetch issue.
 */
/** Lê do localStorage se este utilizador já dispensou o aviso. Leitura
 *  síncrona, logo pode ser feita durante o render. */
function wasDismissed(userId: string): boolean {
  try {
    const raw = localStorage.getItem(DISMISS_KEY)
    if (!raw) return false
    const map = JSON.parse(raw) as Record<string, number>
    return !!map[userId]
  } catch {
    return false
  }
}

function PasswordSetupBanner() {
  const { mode, user, workspace, hasPassword } = useAuth()
  const [dismissed, setDismissed] = useState(false)

  // Adotado durante o render com guarda pelo id do utilizador, em vez de
  // um efeito com setState síncrono. Tal como antes, só liga a flag
  // (nunca a desliga), para não reabrir o aviso a meio da sessão.
  const [lastUserId, setLastUserId] = useState<string | null>(null)
  if (user && user.id !== lastUserId) {
    setLastUserId(user.id)
    if (wasDismissed(user.id)) setDismissed(true)
  }

  if (mode !== 'cloud' || !user || hasPassword || dismissed) return null

  const dismiss = () => {
    setDismissed(true)
    try {
      const raw = localStorage.getItem(DISMISS_KEY)
      const map = raw ? (JSON.parse(raw) as Record<string, number>) : {}
      map[user.id] = Date.now()
      localStorage.setItem(DISMISS_KEY, JSON.stringify(map))
    } catch {
      /* ignore */
    }
  }

  return (
    <div className="flex shrink-0 items-center gap-2 border-b border-[var(--color-accent-border)] bg-[var(--color-accent-bg)] px-3 py-1.5 text-xs">
      <span className="text-[var(--color-accent)]">
        Define uma password para entrar mais rapidamente da próxima vez.
      </span>
      <Link
        to={
          workspace
            ? `/${workspace.slug}/account/password`
            : '/account/password'
        }
        className="rounded border border-[var(--color-accent-border)] px-2 py-0.5 font-medium text-[var(--color-accent)] hover:text-[var(--color-accent-hover)]"
      >
        Definir agora
      </Link>
      <button
        type="button"
        onClick={dismiss}
        className="ml-auto text-[var(--color-text-dim)] hover:text-[var(--color-text)]"
        title="Esconder"
      >
        ×
      </button>
    </div>
  )
}

export default PasswordSetupBanner
